import React from 'react';
import { useSelector } from 'react-redux';
import config from 'Config';
import ContactUs from 'components/ContactUs';
import { useLocation } from 'react-router-dom';

const Component = () => {
  const store = useSelector((state) => state.store);
  const { customerServicePhoneNumber, contactUsLink } = config;
  const url = useLocation().pathname;

  return (
    <ContactUs
      storeUrl={store && store.url}
      isStartPage={url === '/start'}
      {...{
        customerServicePhoneNumber,
        contactUsLink,
      }}
    />
  );
};

Component.displayName = 'ContactUsContainer';

export default Component;
